module.exports = __webpack_public_path__ + "img/about-light.d62dbd9c.png";